// component
import { Icon } from '@iconify/react';

// ----------------------------------------------------------------------

const icon = (iconName) => <Icon icon={iconName} width={20} height={20} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard-admin',
    icon: icon('solar:widget-5-bold-duotone'),
  },
  {
    title: 'hub ops',
    path: '/hub-ops',
    icon: icon('mdi:warehouse'),
  },
  {
    title: 'packages',
    icon: icon('mdi:package-variant-closed'),
    children: [
      { title: 'add package', path: '/add-package' },
      { title: 'package list', path: '/packages' },
    ],
  },
  {
    title: 'hub scan',
    icon: icon('solar:qr-code-bold'),
    children: [
      { title: 'scan package', path: '/scan-package' },
      { title: 'hub queue', path: '/hub-queue' },
      { title: 'transfer to third party', path: '/transfer-third-party' },
      { title: 'scanned packages', path: '/scanned-packages' },
    ],
  },
  {
    title: 'RTO',
    icon: icon('mdi:package-up'),
    children: [
      { title: 'RTO actions', path: '/rto' },
      { title: 'RTO list', path: '/rto-list' },
    ],
  },
  {
    title: 'out for delivery',
    path: '/scan-out-of-delivery',
    icon: icon('mdi:truck-delivery'),
    children: [
      { title: 'out of delivery scan', path: '/scan-out-of-delivery' },
      { title: 'out of delivery packages', path: '/out-of-delivery-packages' },
    ],
  },
  {
    title: 'delivery',
    icon: icon('mdi:package-check'),
    children: [
      { title: 'scan delivery', path: '/delivered' },
      { title: 'delivery list', path: '/delivery-lists' },
    ],
  },
  {
    title: 'deliveries & to-pays',
    icon: icon('mdi:cash-multiple'),
    children: [
      { title: 'deliveries', path: '/deliveries' },
      { title: 'to pays', path: '/to-pays' },
      { title: 'collections', path: '/collections' },
    ],
  },
  {
    title: 'bills',
    icon: icon('solar:bill-list-bold'),
    children: [
      { title: 'generate bill', path: '/generate-billing' },
      { title: 'previous bills', path: '/show-bills' },
    ],
  },
  {
    title: 'client',
    icon: icon('solar:users-group-rounded-bold'),
    children: [
      { title: 'add client', path: '/add-client' },
      { title: 'all clients', path: '/clients' },
    ],
  },
  {
    title: 'employee',
    icon: icon('solar:user-id-bold'),
    children: [
      { title: 'add employee', path: '/add-employee' },
      { title: 'all employees', path: '/employees' },
      { title: 'attendance', path: '/attendance' },
    ],
  },
  {
    title: 'vehicle',
    icon: icon('mdi:truck-outline'),
    children: [
      { title: 'add vehicle', path: '/add-vehicle' },
      { title: 'all vehicles', path: '/vehicles' },
    ],
  },
  {
    title: 'enquiries',
    path: '/enquiries',
    icon: icon('solar:chat-round-dots-bold'),
  },
  {
    title: 'WhatsApp inbox',
    path: '/whatsapp-inbox',
    icon: icon('ic:baseline-whatsapp'),
  },
  // {
  //   title: 'user',
  //   path: '/user',
  //   icon: icon('ic_user'),
  // },
  // {
  //   title: 'product',
  //   path: '/dashboard/products',
  //   icon: icon('ic_cart'),
  // },
  // {
  //   title: 'blog',
  //   path: '/dashboard/blog',
  //   icon: icon('ic_blog'),
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic_disabled'),
  // },
];

export default navConfig;
